const getLoading = ({ loading }) => loading.get("isLoading");

export default {
  getLoading
};
